
















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  NotificationAPI,
  WebClientMessageEntity,
  WebClientMessageStatus
} from '@/api/notification'
import ServerError from '@/utils/server_error'
import authStore from '@/modules/auth/auth.store'
import { getModule } from 'vuex-module-decorators'
import { HubConnection } from '@microsoft/signalr'
import { getRealtimeConnection } from '@/utils/realtime'
import { CancelError, CancellationToken } from '@/utils/cancel'

@Component
export default class NotificationCenter extends Vue {
  userModule = getModule(authStore, this.$store)

  loading: boolean = false
  messages: WebClientMessageEntity[] = []
  pageMessages: WebClientMessageEntity[] = []
  popupMessages: WebClientMessageEntity[] = []

  unread: number = 0
  page: number = 1
  maxPage: number = 1
  isOpen: boolean = false

  realtimeConnection!: HubConnection
  realtimeConnectionCancellationToken = new CancellationToken()

  iconSize: number = 36
  snackbar: boolean = true

  @Watch('isOpen')
  async onIsOpenChanged(newVal: boolean) {
    if (this.unread > 0) {
      /* this.unread = Math.max(0, this.unread - 20)
      try {
        await WebClientMessageAPI.setMessageRead(
          this.messages.map(message => message.webClientMessageId)
        )
      } catch (err) {
        console.error(err)
      } */

      this.unread = 0
      try {
        await NotificationAPI.setMessageRead([])
      } catch (err) {
        console.error(err)
      }
      this.popupMessages.splice(0, this.popupMessages.length)
    }

    if (!newVal) {
      setTimeout(() => {
        this.messages = []
        this.pageMessages = []
        this.page = 1
        this.maxPage = 1
        this.fetchWebClientMessages().then()
      }, 200)
    }
  }

  @Watch('hasLoggedIn')
  async onLoginStateChanged() {
    if (this.hasLoggedIn) {
      await this.init()
    } else {
      await this.shutdown()
    }
  }

  async init() {
    await this.fetchWebClientMessages()

    try {
      this.realtimeConnection = await getRealtimeConnection(
        this.realtimeConnectionCancellationToken
      )
    } catch (err) {
      if (err instanceof CancelError) {
        return
      }

      this.$toast.error(this.$t('Landing.FailConnectServerMessage'))
      console.error(err)
    }
    this.realtimeConnection.on('newMessage', this.onNewMessage)

    for (const message of this.messages.filter(
      msg => msg.status === WebClientMessageStatus.Delivered
    )) {
      this.showPopupMessage(message)
    }
  }

  async shutdown() {
    this.realtimeConnectionCancellationToken.cancel()
    if (this.realtimeConnection) {
      this.realtimeConnection.off('newMessage', this.onNewMessage)
    }
  }

  async mounted() {
    if (this.hasLoggedIn) {
      await this.init()
    }
  }

  async beforeDestroy() {
    await this.shutdown()
  }

  async fetchWebClientMessages() {
    if (this.loading) {
      return
    }

    this.loading = true

    try {
      const res = await NotificationAPI.getWebClientMessages(this.page)
      this.pageMessages = res.data.payload!.messages
      this.messages = [...this.messages, ...this.pageMessages]
      this.unread = res.data.payload!.unread
      this.maxPage = res.data.payload!.maxPage
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error('Server error')
      }

      console.error(err)
    } finally {
      this.loading = false
    }
  }

  async onScroll(e: MouseEvent) {
    if (this.loading) {
      return
    }

    if (this.page >= this.maxPage) {
      return
    }

    const container = e.target as HTMLDivElement
    if (!container) {
      return
    }

    const topRequired =
      container.scrollHeight -
      container.offsetHeight -
      (container.scrollHeight - container.offsetHeight) / 2

    if (container.scrollTop < topRequired) {
      return
    }

    this.page++

    await this.fetchWebClientMessages()

    if (this.unread > 0) {
      try {
        await NotificationAPI.setMessageRead(
          this.pageMessages.map(message => message.webClientMessageId)
        )
      } catch (err) {
        console.error(err)
      }
    }
  }

  onNewMessage(message: WebClientMessageEntity) {
    this.messages = [message, ...this.messages]
    this.unread++

    this.showPopupMessage(message)
  }

  get hasLoggedIn() {
    return this.userModule.hasLoggedIn
  }

  get WebClientMessageStatus() {
    return WebClientMessageStatus
  }

  showPopupMessage(message: WebClientMessageEntity) {
    this.popupMessages.push(message)
  }

  async readMessageAndClose(message: WebClientMessageEntity, close: Function) {
    close()
    try {
      await NotificationAPI.setMessageRead([message.webClientMessageId])

      message.readTime = new Date().getTime() / 1000
      message.status = WebClientMessageStatus.Read

      this.unread--
      if (this.unread < 0) this.unread = 0
    } catch (err) {
      console.error('Unable to set message to read', err)
    }
  }
}
